import React from 'react';
import { Box, Typography } from '@mui/material';

const Settings = {
  Name: 'Text',
  Display: true,
  options: {
    view: null,
    settings: [
      { id: 'title', type: 'text', name: 'Title' },
      { id: 'text', type: 'textarea', name: 'Text' },
    ],
    grid: true,
  },
};

const View = ({ Settings: userSettings = {} }) => (
  <Box>
    {userSettings.title ? (
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5 }}>
        {userSettings.title}
      </Typography>
    ) : null}
    <Typography sx={{ whiteSpace: 'pre-wrap' }}>{userSettings.text || ''}</Typography>
  </Box>
);

export default {
  Settings,
  View,
};
